import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { requestSyncUnprocessedEvent } from "services/events/aboutEvents";
import useMainContext from "utils/context/useMainContext";

const ERRORS = {
    NO_REQUEST_PENDING: "SIN_PETICION_PEND"
};

const useSyncOfEventUnprocessed = ({
    setCanShowDialogLeavingView,
}) => {
    const mainContext = useMainContext();
    //#region States
    const [inSyncOfEventUnprocessed, setInSyncOfEventUnprocessed] = useState(false);
    const [syncEventUnprocessedData, setSyncEventUnprocessedData] = useState(null);
    const [notExistPendingRecords, setNotExistPendingRecords] = useState(false);
    //#endregion
    const dialogShowSuccessNotification = useShowDialogAlert();
    //#region Functions
    const doSync = async () => {
        setCanShowDialogLeavingView(true);
        setInSyncOfEventUnprocessed(true);
        const data = await requestSyncUnprocessedEvent();
        setInSyncOfEventUnprocessed(false);
        setCanShowDialogLeavingView(false);
        // Error de petición
        if (!data) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        // Sincronización correcta
        if (!data.message) {
            setSyncEventUnprocessedData(data);
            dialogShowSuccessNotification.toggle();
            return;
        }
        // Errores controlados
        switch (data.message) {
            case ERRORS.NO_REQUEST_PENDING:
                mainContext.setDialogUnexpectedErrorMessage("No hay peticiones pendientes por actualizar.");
                setNotExistPendingRecords(true);
                break;
            default: break;
        }
        mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return {
        doSync, inSync: inSyncOfEventUnprocessed,
        notExistPendingRecords,
        data: syncEventUnprocessedData,
        dialogShow: dialogShowSuccessNotification
    };
}

export default useSyncOfEventUnprocessed;